import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceDefinitionComponent } from './service-definition.component';
import { MatDividerModule } from '@angular/material/divider';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { ServiceDefinitionRoutingModule } from './service-definition-routing.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { SandboxDynamicFormModule } from 'src/app/components/sandbox-dynamic-form/sandbox-dynamic-form.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { QuestionnaireSummaryModule } from 'src/app/components/questionnaire-summary/questionnaire-summary.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    ServiceDefinitionComponent
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    BreadcrumbModule,
    ServiceDefinitionRoutingModule,
    IconsModule,
    SharedModule,
    DynamicFormModule,
    SandboxDynamicFormModule,
    ErrorModule,
    ReactiveFormsModule,
    FormsModule,
    QuestionnaireSummaryModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule
  ]
})
export class ServiceDefinitionModule { }
